import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-dialog-title" }
const _hoisted_2 = {
  ref: "slotButtonContainer",
  class: "flex justify-content-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_PrimeDialog = _resolveComponent("PrimeDialog")!

  return (_openBlock(), _createBlock(_component_PrimeDialog, {
    visible: _ctx.visible,
    style: { width: '460px' },
    class: _normalizeClass(["p-dialog--prompt", 'p-dialog--' + _ctx.type]),
    closable: false,
    draggable: false,
    modal: true,
    onShow: _ctx.onShow
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_Title, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.title), 1)
          ]),
          _: 1
        })
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "actions")
      ], 512)
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "content")
    ]),
    _: 3
  }, 8, ["visible", "class", "onShow"]))
}